export default () => {
    return localStorage.getItem('app_key');
};